import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormInput from '../form-input';
import Validate from '../../../../app/validation/validation';
import './index.scss';

const CreateForm = ({
  isPartialForm = false,
  isProcessing = false,
  onSubmit = () => {},
  onTouch = () => {},
}) => {
  const translations = useSelector((store) => store.config.Translations);

  const [formState, setFormState] = useState({
    name: {
      unique: 'name',
      label: translations['forum_name_input_label'],
      type: 'text',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: false,
      displayInPartial: true,
      rules: ['not_empty'],
      minLength: 1,
      maxLength: 50,
    },
    region: {
      unique: 'region',
      label: translations['forum_region_input_label'],
      type: 'select',
      value: '',
      error: '',
      valid: false,
      options: [
        { id: 1, text: 'צפון הארץ' },
        { id: 2, text: 'אזור השרון' },
        { id: 3, text: 'אזור מרכז' },
        { id: 4, text: 'ירושלים והסביבה' },
        { id: 5, text: 'דרום הארץ' },
      ],
      required: false,
      internalUsage: false,
      displayInPartial: false,
      rules: [],
    },
    email: {
      unique: 'email',
      label: translations['forum_email_input_label'],
      type: 'email',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: true,
      displayInPartial: true,
      rules: ['not_empty', 'email'],
      minLength: 1,
      maxLength: 100,
    },
    phone: {
      unique: 'phone',
      label: translations['forum_phone_input_label'],
      type: 'tel',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: true,
      displayInPartial: true,
      rules: ['not_empty', 'phone'],
      minLength: 10,
      maxLength: 12,
    },
    city: {
      unique: 'city',
      label: translations['forum_city_input_label'],
      type: 'text',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: false,
      displayInPartial: false,
      rules: ['not_empty'],
      minLength: 1,
      maxLength: 100,
    },
    // address: {
    //   unique: 'address',
    //   label: translations['forum_address_input_label'],
    //   type: 'text',
    //   value: '',
    //   error: '',
    //   valid: false,
    //   required: false,
    //   internalUsage: true,
    //   displayInPartial: false,
    //   rules: [],
    //   minLength: 0,
    //   maxLength: 100,
    // },
    subject: {
      unique: 'subject',
      label: translations['forum_subject_input_label'],
      type: 'text',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: false,
      displayInPartial: false,
      rules: ['not_empty'],
      minLength: 1,
      maxLength: 100,
    },
    description: {
      unique: 'description',
      label: translations['forum_description_input_label'],
      type: 'textarea',
      value: '',
      error: '',
      valid: false,
      required: true,
      internalUsage: false,
      displayInPartial: true,
      rules: ['not_empty'],
      minLength: 1,
      maxLength: 1000,

    },
  });
  const [wasSubmitPressed, setWasSubmitPressed] = useState(false);

  const formStructure = [
    [ formState.name, formState.phone ],
    [ formState.email ],
    [ formState.city, formState.region ],
    [ formState.subject ],
    [ formState.description ],
  ];

  const handleFormSubmit = (event) => {
    event.preventDefault();

    if (isProcessing) return;

    let isFormValid = true;
    const newFormState = { ...formState };

    Object.keys(newFormState).forEach((input) => {
      if (isPartialForm && !newFormState[input].displayInPartial) return;
      const validation = Validate(newFormState[input].value, newFormState[input].rules);

      newFormState[input] = {
        ...newFormState[input],
        error: validation.msg,
        valid: validation.valid,
      };

      if (!validation.valid) {
        isFormValid = false;
      }
    });

    if (isFormValid) {
      const formData = {};

      Object.keys(formState).forEach((key) => {
        if (formState[key].value === '') return;
        formData[key] = formState[key].value;
      });

      onSubmit(formData);
    }

    setFormState(newFormState);
    setWasSubmitPressed(true);
  };

  const handleFieldChange = ({ target }) => {
    const validation = Validate(target.value, formState[target.name].rules);

    setFormState({
      ...formState,
      [target.name]: {
        ...formState[target.name],
        value: target.value,
        error: validation.msg,
        valid: validation.valid,
      },
    });

    onTouch();
  };

  return (
    <form className="forum-create-form" onSubmit={handleFormSubmit}>
      {formStructure.map((row, index) => {
        if (
          isPartialForm &&
          row.every((input) => input.displayInPartial === false)
        ) return null;

        return (
          <div key={`row-${index}`} className="form-inputs-row">
            {row.map((input) => {
              const { displayInPartial, ...remaining } = input;
              if (isPartialForm && !displayInPartial) return null;

              return (
                <FormInput
                  key={`form-input-${remaining.unique}`}
                  wasSubmitPressed={wasSubmitPressed}
                  onChange={handleFieldChange}
                  {...remaining}
                />
              );
            })}
          </div>
        );
      })}

      <button
        type="submit"
        className="form-submit-button"
        disabled={isProcessing}
      >
        {translations['forum_send_button']}
      </button>
    </form>
  );
};

export default CreateForm;
